import { ItemTypeServiceBase } from "../entities/item-type-service-base";
import {ItemType} from "../entities/item-type";
import {autoinject} from 'aurelia-dependency-injection';
import {EntityManager} from "aurelia-orm";

@autoinject()
export class ItemTypeDataService extends ItemTypeServiceBase<ItemType> {
    constructor(entityManager: EntityManager) {
        super("ItemType", entityManager);
    }
    getItemTypes() {
        return this.repository.find();
    }
}